import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Search, MapPin } from "lucide-react";
import LocationAutocomplete from "@/components/LocationAutocomplete";

const CITIES = ["Any city", "Kota", "Jaipur", "Sikar", "Ajmer", "Udaipur", "Jodhpur", "Delhi", "Hyderabad", "Bangalore", "Chennai", "Pune", "Rajkot"];

export default function SearchBar({ compact = false }) {
  const [city, setCity] = useState("Any city");
  const [q, setQ] = useState("");
  const [gender, setGender] = useState("any");
  const nav = useNavigate();

  const handleSelect = (item) => {
    if (!item) return;
    if (item.type === "hostel" && item.hostel_id) {
      nav(`/hostels/${item.hostel_id}`);
      return;
    }
    if (item.type === "coaching" && item.coaching) {
      const params = new URLSearchParams();
      params.set("coaching", item.coaching);
      if (item.city) params.set("city", item.city);
      nav(`/hostels?${params}`);
      return;
    }
    if (item.type === "city" && item.slug) {
      nav(`/${item.slug}`);
      return;
    }
    if (item.type === "area") {
      const params = new URLSearchParams();
      params.set("q", item.label);
      if (item.city) params.set("city", item.city);
      nav(`/hostels?${params}`);
      return;
    }
    setQ(item.label);
  };

  const submit = (e) => {
    e.preventDefault();
    const p = new URLSearchParams();
    if (city && city !== "Any city") p.set("city", city);
    if (q) p.set("q", q);
    if (gender !== "any") p.set("gender", gender);
    nav(`/hostels?${p.toString()}`);
  };

  return (
    <form onSubmit={submit} data-testid="search-form"
      className={`bg-white border border-slate-200 shadow-sm rounded-2xl p-2 flex flex-col md:flex-row gap-2 ${compact ? "" : "md:items-stretch"}`}>
      <div className="flex-1 flex items-center gap-2 px-3 py-2 rounded-xl hover:bg-slate-50 focus-within:bg-slate-50 transition-colors">
        <MapPin size={16} className="text-orange-800 shrink-0" />
        <Select value={city} onValueChange={setCity}>
          <SelectTrigger data-testid="search-city" className="border-0 bg-transparent shadow-none focus:ring-0 h-9 px-0 font-semibold">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {CITIES.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      <div className="flex-1 border-l border-slate-100 md:border-l relative min-w-0">
        <LocationAutocomplete value={q} onSelect={handleSelect} placeholder="Coaching, area, hostel or landmark…" />
      </div>
      <div className="flex items-center gap-2 px-3 py-2 rounded-xl hover:bg-slate-50 transition-colors md:border-l border-slate-100">
        <Select value={gender} onValueChange={setGender}>
          <SelectTrigger data-testid="search-gender" className="border-0 bg-transparent shadow-none focus:ring-0 h-9 px-0 font-semibold min-w-[120px]">
            <SelectValue placeholder="Anyone" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="any">Anyone</SelectItem>
            <SelectItem value="boys">Boys</SelectItem>
            <SelectItem value="girls">Girls</SelectItem>
            <SelectItem value="coed">Co-ed</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <Button data-testid="search-submit" type="submit" className="rounded-xl bg-orange-800 hover:bg-orange-900 text-white h-12 md:h-auto md:px-8 gap-2">
        <Search size={16} /> Search
      </Button>
    </form>
  );
}
